import _ from 'underscore';
import Promise from 'bluebird';
import { withUiBlock as originalWithUiBlock } from '@bingads-webui/uiblocker';

const {
  map, clone, pluck, isEmpty, filter, noop,
} = _;

const withUiBlock =
  _.partial(originalWithUiBlock, /* target */ _, /* loadingText */ _, /* shouldFocus */ false);

// current limitation is 100, the 1200000 is just to be a safe number
const FeedsToFetch = 200;
let feeds = [];

const getAllFeeds = _.once((el, jsDataCampaign) => {
  if (isEmpty(feeds)) {
    const filterQuery = 'Status eq Enum.FeedStatus\'Active\' and FeedCategories/any(c:c eq Enum.FeedCategory\'AdCustomizer\')';
    const uiBlock = el ? withUiBlock(el) : noop;

    return jsDataCampaign.Feed
      .findAll({ query: { $filter: filterQuery }, limit: FeedsToFetch })
      .finally(uiBlock)
      .then((returnResult) => {
        if (returnResult.totalCount > 0) {
          feeds = map(returnResult, (item) => {
            const { Name, Attributes, Id } = item || {};

            return {
              Name,
              AttributeNames: pluck(Attributes, 'Name'),
              Id,
            };
          });
        }

        return feeds;
      }).catch(() => []);
  }
  return Promise.resolve(feeds);
});

export function cloneFeed(orignalFeed) {
  const { Id, AttributeNames, Name } = orignalFeed;

  return {
    Id,
    Name,
    AttributeNames: clone(AttributeNames),
  };
}

function cloneFeeds(originalFeeds) {
  return map(originalFeeds, cloneFeed);
}

// the feeds will be returned as the structure of
// [{Name, AttributeNames}]
export function queryFeedsByName({
  jsDataCampaign, namePrefix: rawNamePrefix = '', container = null, useExactMatch = false,
}) {
  const namePrefix = (rawNamePrefix || '').trim().toLowerCase();
  return getAllFeeds(container, jsDataCampaign).then((allFeeds) => {
    if (isEmpty(namePrefix)) {
      return cloneFeeds(allFeeds);
    }

    return filter(allFeeds, (feed) => {
      const feedNameToUse = feed && feed.Name ? feed.Name.toLowerCase() : '';

      return feedNameToUse &&
        (useExactMatch ?
          feedNameToUse === namePrefix :
          feedNameToUse.indexOf(namePrefix) === 0);
    });
  });
}
